export let handAvatar = {
	bindings: {
		activity: '<',
	},
	template: `
    <span class="icon i-28 md-avatar" ng-class="vm.showHand(vm.activity)">
      <md-tooltip class="custom-tooltip" md-direction="right">
        {{::vm.approved}}
      </md-tooltip>
    </span>`,
	controllerAs: 'vm',
	controller  : [ 'CssClasses', '$stateParams', 'Ramda', 'GlobalConfig',
		function handAvatarCtrl (CssClasses, $stateParams, Ramda, GlobalConfig) {
			const { curry } = Ramda
			const textColor = CssClasses.textColor
			const icons = CssClasses.icons
			const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage
			const inHistory = $stateParams.inHistory

			const setColors = curry((scope, param, activity) => {
				if (activity[param] === 1) {
					scope.approved = 'Aprobado'

					return [ textColor.blue, icons.thumbsUp ]
				} else if (activity[param] === 0) {
					scope.approved = 'Rechazado'

					return [ textColor.red, icons.thumbsDown ]
				}
			})

			const handAvatar = curry((setColors, currentStage, activity) => {
				switch (currentStage) {

				case 'reviewExecution':
					return setColors('isExecution')(activity)
				case 'review':
					return setColors('isReviewed')(activity)
				case 'execution':
					return setColors('isApproved')(activity)
				case 'evaluation':
					return setColors('isAccept')(activity)
				case 'approval':
					return setColors('isApproved')(activity)
				
				}
			})

			const handAvatarInHistory = curry((setColors, activity) => {
				switch (activity.stageId) {

				case GlobalConfig.workplanIdStages.approval:
					return setColors('isReviewed')(activity)
				case GlobalConfig.workplanIdStages.execution:
					return setColors('isApproved')(activity)
				case GlobalConfig.workplanIdStages.reviewExecution:
					return setColors('isApproved')(activity)
				case GlobalConfig.workplanIdStages.evaluation:
					return setColors('isExecution')(activity)
				case GlobalConfig.workplanIdStages.end:
					return setColors('isAccept')(activity)
				default:
					return setColors('isReviewed')(activity)
				
				}
			})

			const showHand = inHistory ? handAvatarInHistory(setColors(this)) : handAvatar(setColors(this), currentStage)

			angular.extend(this, {
				showHand: showHand,
				approved: '',
			})
		},
	] }


// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activities-list/hand-avatar.js